import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountBalanceDTO  {
    _originalTypeClassName = "zERP.BO.CashAccountBalanceDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountBalanceDTO.translate = translateService;
}
this.Items = [];
this.TotalCashReceivedInvoicesNumber = null;
this.TotalCashReceivedAmount = null;
this.TotalCashPaidInvoicesNumber = null;
this.TotalCashPaidAmount = null;
this.TotalCashBalance = null;
this.TotalPOSReceivedInvoicesNumber = null;
this.TotalPOSReceivedAmount = null;
this.TotalPOSPaidInvoicesNumber = null;
this.TotalPOSPaidAmount = null;
this.TotalPOSBalance = null;
this.TotalChecksReceivedInvoicesNumber = null;
this.TotalChecksReceivedAmount = null;
this.TotalChecksPaidInvoicesNumber = null;
this.TotalChecksPaidAmount = null;
this.TotalChecksBalance = null;
this.PreviousCashBalance = null;
this.CashBalance = null;
this.CashAccountBalanceDTOKey = null;
this._key = this.CashAccountBalanceDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
TotalCashReceivedInvoicesNumber:any;
TotalCashReceivedAmount:any;
TotalCashPaidInvoicesNumber:any;
TotalCashPaidAmount:any;
TotalCashBalance:any;
TotalPOSReceivedInvoicesNumber:any;
TotalPOSReceivedAmount:any;
TotalPOSPaidInvoicesNumber:any;
TotalPOSPaidAmount:any;
TotalPOSBalance:any;
TotalChecksReceivedInvoicesNumber:any;
TotalChecksReceivedAmount:any;
TotalChecksPaidInvoicesNumber:any;
TotalChecksPaidAmount:any;
TotalChecksBalance:any;
PreviousCashBalance:any;
CashBalance:any;
Items:any;
private _CashAccountBalanceDTOKey:any;
get CashAccountBalanceDTOKey(): any {
    return this._CashAccountBalanceDTOKey;
  }
set CashAccountBalanceDTOKey(value: any) {
    this._CashAccountBalanceDTOKey = value;
    this._key = value;
  }
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.CashAccountBalanceDTO.removeItems($this, $this.Items[0]);
                }

                Domain.CashAccountBalanceDTO.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountBalanceDTO.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountBalanceDTO.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }

static UpdateTotals($this: any): any{$this.TotalCashReceivedInvoicesNumber = $this?.Items?.linq?.sum((i) => i?.Cash?.ReceivedInvoicesNumber);
$this.TotalCashReceivedAmount = $this?.Items?.linq?.sum((i) => i?.Cash?.ReceivedAmount);
$this.TotalCashPaidInvoicesNumber = $this?.Items?.linq?.sum((i) => i?.Cash?.PaidInvoicesNumber);
$this.TotalCashPaidAmount = $this?.Items?.linq?.sum((i) => i?.Cash?.PaidAmount);
$this.TotalCashBalance = Joove.Common.safeNumber($this?.TotalCashReceivedAmount) - Joove.Common.safeNumber($this?.TotalCashPaidAmount);
$this.TotalPOSReceivedInvoicesNumber = $this?.Items?.linq?.sum((i) => i?.POS?.ReceivedInvoicesNumber);
$this.TotalPOSReceivedAmount = $this?.Items?.linq?.sum((i) => i?.POS?.ReceivedAmount);
$this.TotalPOSPaidInvoicesNumber = $this?.Items?.linq?.sum((i) => i?.POS?.PaidInvoicesNumber);
$this.TotalPOSPaidAmount = $this?.Items?.linq?.sum((i) => i?.POS?.PaidAmount);
$this.TotalPOSBalance = Joove.Common.safeNumber($this?.TotalPOSReceivedAmount) - Joove.Common.safeNumber($this?.TotalPOSPaidAmount);
$this.TotalChecksReceivedInvoicesNumber = $this?.Items?.linq?.sum((i) => i?.Checks?.ReceivedInvoicesNumber);
$this.TotalChecksReceivedAmount = $this?.Items?.linq?.sum((i) => i?.Checks?.ReceivedAmount);
$this.TotalChecksPaidInvoicesNumber = $this?.Items?.linq?.sum((i) => i?.Checks?.PaidInvoicesNumber);
$this.TotalChecksPaidAmount = $this?.Items?.linq?.sum((i) => i?.Checks?.PaidAmount);
$this.TotalChecksBalance = Joove.Common.safeNumber($this?.TotalChecksReceivedAmount) - Joove.Common.safeNumber($this?.TotalChecksPaidAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountBalanceDTOKey == null || $this.CashAccountBalanceDTOKey == 0;
            }


}